import axios from 'axios'
import settings from '../../settings'

const groups = {
    namespaced: true,
    state: () => ({
        all:[]
      }),
      mutations:{
         updategroupsState(state,data){
             state.all=data;
         }
      },
      actions: {
        fetchgroups({commit}){
            axios.get(`${settings.apiUrl}/groups`).then(res => {
					commit('updategroupsState',res.data)
			 });
        },
        updateSequence({dispatch}, {data}) {
          const sec=new FormData();
          sec.append('data',JSON.stringify(data));
          axios.post(`${settings.apiUrl}/v2/groups/sequence`, sec).then(res => {
            dispatch('fetchgroups');
          });
        },
      },
    
      getters: {
           
      }
}

export default groups;

 